var React = require('react');

function StopCancelLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 48a24 24 0 110-48 24 24 0 010 48zm0-46a22 22 0 100 44 22 22 0 000-44z","key":0}),React.createElement("path",{"d":"M40.31 41.26a1 1 0 01-.71-.29L7.07 8.44a1 1 0 111.42-1.41L41 39.55a1 1 0 01-.69 1.71z","key":1})]);
}

StopCancelLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StopCancelLight;

StopCancelLight.default = StopCancelLight;
